import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, X } from 'lucide-react';
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Posadas', 'Resistencia', 'Corrientes', 'Bahía Blanca'];
const NAMES = ['María', 'Laura', 'Florencia', 'Valentina', 'Luciana', 'Carolina', 'Mariana', 'Agustina', 'Sofía', 'Camila', 'Julieta', 'Martina', 'Paula', 'Daniela', 'Romina'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Show first popup after 10 seconds for demonstration, then every 2 minutes
    const showPopup = () => {
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      setPurchaseData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimer = setTimeout(showPopup, 10000);
    const intervalTimer = setInterval(showPopup, 120000); // 2 minutes
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-11">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-xl shadow-lg border border-violet-100 p-4 z-50 flex items-start gap-3" data-id="element-12">
          <div className="bg-violet-100 p-2 rounded-full flex-shrink-0" data-id="element-13">
            <MapPin className="w-5 h-5 text-violet-600" data-id="element-14" />
          </div>
          <div className="flex-1" data-id="element-15">
            <p className="text-sm font-medium text-gray-900" data-id="element-16">
              {purchaseData.name} de {purchaseData.city}
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-17">
              Compró el Ultrapack hace unos minutos
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600" data-id="element-18">
            <X className="w-4 h-4" data-id="element-19" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}